import { OfferStatus } from './../../../../../shared/enums/offer-status/offer-status.module';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { Component as ComponentModel } from '../../../../../models/component.model';
import { Block } from '../../../../../models/block.model';
import { ComponentsGroup } from '../../../../../models/componentGroup.model';
import { CustomerPageData } from '../../../../../models/customerPageData.model';
import { UtilsService } from '../../../../../services/shared/utils/utils.service';
import { CustomerPageDataService } from '../../../../../services/customerPageData/customerPageData.service';
import { SnackbarService } from '../../../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { KeyValue } from '@angular/common';
import { ComponentType } from '../../../../../shared/enums/component-type/component-type.module';
import { InputType } from '../../../../../shared/enums/input-type/input-type.module';
import { FileStatus } from '../../../../../shared/enums/file-status/file-status.module';
import { FileData } from '../../../../../models/fileData.model';
import { Condition } from '../../../../../models/condition.model';
import { ComponentFormComponent } from './component-form/component-form.component';
import { Customer } from '../../../../../models/customer.model';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleType } from '../../../../../shared/enums/role-type/role-type.module';
import { CustomerPage } from '../../../../../models/customerPage.model';
import { ColorPicker } from '../../../../../models/colorPicker.model';
import { TooltipPosition } from '../../../../../models/tooltipPosition.model';
import { AuthService } from '../../../../../services/auth/auth.service';
import { LocalStorageService } from '../../../../../services/shared/local-storage/local-storage.service';
import { Subject, takeUntil } from 'rxjs';
import { RefBusinessLists } from '../../../../../models/refBusinessLists.model';
import { CommonService } from '../../../../../services/shared/common/common.service';
import { ConnectionDefinition } from '../../../../../models/connectionDefinition.model';
import { ConnectionOutStatus } from '../../../../../shared/enums/connection-out-status/connection-out-status.module';
import { DialogService } from '../../../../../services/shared/dialog/dialog.service';
import { ContentActivityPrestations } from '../../../../../models/contentActivityPrestations.model';
import { AppStateService } from '../../../../../services/shared/app-state/app-state.service';

@Component({
  selector: 'app-group-form',
  templateUrl: './group-form.component.html',
  styleUrl: './group-form.component.css'
})
export class GroupFormComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  @Input() customerPage!: CustomerPage;
  @Input() block!: Block;
  @Input() customer!: Customer;
  @Input() isSummary!: boolean;
  @Input() componentsGroup!: ComponentsGroup;
  @Input() customersData!: CustomerPageData[];
  @Input() userRole!: RoleType;
  @Input() offerStatus!: OfferStatus;
  @Input() refBusinessLists!: RefBusinessLists;
  @Input() fullConnectionsDefinitions!: ConnectionDefinition[];
  @Input() isCurrentBlock!: boolean;
  @Output() customersDataChange = new EventEmitter<CustomerPageData[]>();
  @Output() scrollToSchedule2: EventEmitter<HTMLElement> = new EventEmitter();
  @Output() fieldContainerClick = new EventEmitter<HTMLElement>();
  @Output() recalculateTooltipsPosition = new EventEmitter;
  @Output() closeAllTooltipsExceptCurrent = new EventEmitter<string>();

  defaultColor: string = '#00000000';
  customersDataGrouped: { [key: string]: CustomerPageData[] } = {};
  totalDataGroups: number = 0;
  customerPageDataGroup: CustomerPageData[] = [];

  isEditable: boolean = false;
  isPreview: boolean = false;
  @ViewChildren(ComponentFormComponent) componentForms!: QueryList<ComponentFormComponent>;

  ComponentType = ComponentType;

  groupHasActivityPrestations: boolean = false;

  constructor(private router: Router,
    private utils: UtilsService,
    private customerPageDataService: CustomerPageDataService,
    private snackBar: SnackbarService,
    public translationService: TranslationService,
    private route: ActivatedRoute,
    private auth: AuthService,
    private lStorage: LocalStorageService,
    private commonService: CommonService,
    private dialogService: DialogService,
    private appState: AppStateService){}

  //verificar qt dataGroupId
  ngOnInit(): void {
    this.isPreview = this.appState.getIsPreview();
    this.refreshCustomersDataGrouped();
    this.userRole = this.getCurrentUserRole(this.isPreview, this.customerPage.id!);
  }

  ngAfterViewInit() {
    this.isEditable = this.componentForms.some(x => x.isEditable || x.componentConditionedClosedForms.some(y => y.isEditable));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  refreshCustomersDataGrouped(){

    var activities = this.customersData.filter(data => data.component.type == ComponentType.ACTIVITY_PRESTATIONS);
    if(activities.length == 1){
      var activity = (activities[0].values[0] as ContentActivityPrestations);
      if(activity.activity){
        activity.activity.mainIndicator = true;
      }
      this.customersDataChange.emit(this.customersData);
    }

    this.customerPageDataGroup = this.customersData.filter(data => data.groupId === this.componentsGroup.id && data.blockIteration == this.block.iteration);

    const dataGroupIdMap: { [key: string]: number } = {};
    let currentId = 1;

    this.customersDataGrouped = this.customerPageDataGroup.reduce((acc: { [key: number]: CustomerPageData[] }, data: CustomerPageData) => {
      if (!(data.dataGroupId in dataGroupIdMap)) {
        dataGroupIdMap[data.dataGroupId] = currentId++;
      }
      const numericId = dataGroupIdMap[data.dataGroupId];

      if (!acc[numericId]) {
        acc[numericId] = [];
      }
      acc[numericId].push(data);
      return acc;
    }, {} as { [key: number]: CustomerPageData[] });

    //if quantity < min GroupConfi -> fix
    if(Object.keys(this.customersDataGrouped).length < this.componentsGroup.multipleConfig?.minQuantity!)
    {
      this.addDataGroup();
    }

    this.reorderGroupComponentsByOrder();

    this.totalDataGroups = Object.keys(this.customersDataGrouped).length;

    this.groupHasActivityPrestations = this.componentsGroup.components.some(x => x.type == ComponentType.ACTIVITY_PRESTATIONS);
    if(this.groupHasActivityPrestations){
      this.activitiesAlreadySelected = this.calculateActivitiesSelected();
    }
  }

  sortGroupsWithMainIndicator = (a: any, b: any): number => {
    const hasMainIndicatorA = this.groupHasMainIndicator(a.value);
    const hasMainIndicatorB = this.groupHasMainIndicator(b.value);

    if (hasMainIndicatorA && !hasMainIndicatorB) return -1;
    if (!hasMainIndicatorA && hasMainIndicatorB) return 1;
    return 0;
  };

  private groupHasMainIndicator(group: CustomerPageData[]): boolean {
    return group.some(dataComponent =>
      dataComponent.component?.type === ComponentType.ACTIVITY_PRESTATIONS &&
      dataComponent.values?.some(
        (v: any) =>
          (v as ContentActivityPrestations)?.activity?.mainIndicator === true
      )
    );
  }


  trackDataGroupByKey(index: number, item: {key: string, value: CustomerPageData[]}) {
    return item.key;
  }

  reorderGroupComponentsByOrder(){
    Object.keys(this.customersDataGrouped).forEach(key => {
      this.customersDataGrouped[key].sort((a, b) => {
        const componentA = this.getComponentById(a.component.id);
        const componentB = this.getComponentById(b.component.id);

        if (componentA && componentB) {
          return componentA.order! - componentB.order!;
        } else {
          return 0;
        }
      });
    });
  }

  getComponentById(componentId: string): ComponentModel | undefined {
    const component = this.block.componentGroups
    .map(group => group.components.find(component => component.id === componentId))
    .find(component => component !== undefined);

    return component;
  }

  //only on block
  getComponentGroupByComponentId(componentId: string): ComponentsGroup{
    const componentGroup = this.block.componentGroups.find(x => x.components.find(y => y.id === componentId));

    if (!componentGroup) {
      throw new Error(`Component with id ${componentId} not found`);
    }
    return componentGroup;
  }

  canAddGroup(): boolean{
    return (this.componentsGroup.multipleConfig!.maxQuantity === null || this.componentsGroup.multipleConfig!.maxQuantity === undefined || this.totalDataGroups < this.componentsGroup.multipleConfig!.maxQuantity) && this.isEditable;
  }

  addDataGroup(){
    const values = Object.values(this.customersDataGrouped);
    const firstDataGroup= values.length > 0 ? values[0] : undefined;

    if(firstDataGroup){
      const outsideCustomerPageDatas = this.customersData.filter(x => x.dataGroupId === firstDataGroup[0].dataGroupId && x.groupId !== firstDataGroup[0].groupId && x.blockIteration == this.block.iteration);
      firstDataGroup.push(...outsideCustomerPageDatas);
      const newDataGroupId = this.utils.generateGUID();

      firstDataGroup.forEach(customerPageData => {
        var values = this.commonService.buildComponentDefaultValues(customerPageData.component.type!, customerPageData.component.config?.inputType, customerPageData.component.config?.multipleAnswers);

        var newCustomerPageData: CustomerPageData = {
          values: values,
          customer: customerPageData.customer,
          page: customerPageData.page,
          component: customerPageData.component,
          groupId: customerPageData.groupId,
          dataGroupId: newDataGroupId,
          blockIteration: this.block.iteration != undefined ? this.block.iteration : 1,
          connectionOutStatus: ConnectionOutStatus.NONE,
          source: "" //will be set on backend
        }

        this.customersData.push(newCustomerPageData);
        this.customersDataChange.emit(this.customersData);
      });

      this.refreshCustomersDataGrouped();
      setTimeout(() => {
        this.recalculateTooltipsPosition.emit();
      }, 0);
    }
  }

  canRemoveGroup(): boolean {
    const noOneHaveValues = Object.values(this.customersDataGrouped).every(dataGroup =>
      dataGroup.every(customerPageData => customerPageData.values === undefined || customerPageData.values === null || customerPageData.values.every(value => value === null || value === ""))
    );
    return ((noOneHaveValues && this.totalDataGroups > this.componentsGroup.multipleConfig!.initQuantity) ||
            (!noOneHaveValues && this.totalDataGroups > this.componentsGroup.multipleConfig!.minQuantity)) && this.isEditable;
  }

  removeDataGroup(dataGroup: KeyValue<string, CustomerPageData[]>){
    if(this.groupHasActivityPrestations)
    {
      if(!this.dataGroupHasMainActivityPrestations(dataGroup)){
        this.dialogService.confirm(this.translationService.translate('Remove activity'), this.translationService.translate('Deleting the activity will also delete the associated services.')).then((confirmed) => {
          if (confirmed) {
            this.executeRemoveDataGroup(dataGroup);
          }
        });
      }
    }
    else{
      this.dialogService.confirm(this.translationService.translate('Remove answer'), this.translationService.translate('Are you sure you want to delete this answer?')).then((confirmed) => {
        if (confirmed) {
          this.executeRemoveDataGroup(dataGroup);
        }
      });
    }
  }

  executeRemoveDataGroup(dataGroup: KeyValue<string, CustomerPageData[]>)
  {
    var dataGroupDeleted = [...dataGroup.value];
    var dataGroupId = dataGroupDeleted[0].dataGroupId;
    this.customersData = this.customersData.filter(x => x.dataGroupId !== dataGroupId);
    this.customersDataChange.emit(this.customersData);
    this.refreshCustomersDataGrouped();

    setTimeout(() => {
      if (this.isEditable && !this.isPreview) {
        var completionPercent = this.customerPage.completionPercent ?? 0;

        dataGroupDeleted.forEach(dataComponent => {
          if(dataComponent.id && dataComponent.id != '00000000-0000-0000-0000-000000000000'){
            this.customerPageDataService.deleteCustomerPageData(dataComponent.id, completionPercent)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (result: boolean) => {
              },
              error: (error) => {
                this.snackBar.showError(this.translationService.translate('Error deleting customer data'));
              }
            });
          }
        });
      }

      this.recalculateTooltipsPosition.emit();
      if(this.groupHasActivityPrestations){
        this.onActivityChanged();
      }
    }, 0);
  }

  verifyConditions(componentId: string, dataGroup: KeyValue<string, CustomerPageData[]>, dataComponent: CustomerPageData): boolean {
    var component = this.getComponentById(componentId);
    if (!component) return false;

    var conditions = component.conditions;
    if (!conditions || conditions.length === 0) return true;

    const isConditionsSatisfied = conditions.every(condition => {
      const sourceComponent = this.getComponentById(condition.componentId);
      if (!sourceComponent){
        //when source is hidden by role
        return dataComponent.shouldDisplay == true;
      }

      const sourceComponentGroup = this.getComponentGroupByComponentId(condition.componentId);
      //fetch conditioner values
      const values = this.commonService.getConditionerValues(this.customersData, sourceComponent, sourceComponentGroup, condition, this.componentsGroup, dataGroup, this.block.iteration)
      //fetch current component rules
      const rules = condition.rules.filter(rule => rule.value !== null && rule.value !== undefined);

      return this.commonService.isConditionSatisfied(rules, sourceComponent, values);
    });

    // If condicioner target is hidden by role, and the conditioned position is closed, update component config to allow display apart
    if(isConditionsSatisfied && component.config && component.config.conditionPosition == 'closed' && component.config.conditionComponentTarget && !this.getComponentById(component.config.conditionComponentTarget)){
      component.config.conditionPosition = 'apart';
      component.config.conditionComponentTarget = undefined;
      return true;
    }

    return isConditionsSatisfied && (component.config == undefined || component.config.conditionPosition != 'closed');
  }

  getComponentSize(id: string): string {
    var component = this.getComponentById(id);
    if (!this.utils.isDesktop()) {
      return `col-12 col-lg-12 col-md-12`;
    }

    if (component)
      return `col-12 col-lg-${component.size} col-md-${component.size}`;
    else
      return `col-12 col-lg-12 col-md-12`;
  }

  handleCustomerPageDatasChange(customersDataChange: boolean) {
    this.customersDataChange.emit(this.customersData);
  }

  scrollToSchedule(scheduleElement: HTMLElement){
    this.scrollToSchedule2.emit(scheduleElement);
  }
  onComponentFormClick(element: HTMLElement) {
    this.fieldContainerClick.emit(element);
  }

  @Output() tooltipPositions = new EventEmitter<Array<TooltipPosition>>();
  tooltipData: Array<TooltipPosition> = [];
  onTooltipPositionChanged(positionData: TooltipPosition) {
    const existingIndex = this.tooltipData.findIndex((data) => data.index === positionData.index);

    if (existingIndex >= 0) {
      this.tooltipData[existingIndex] = positionData;
    } else {
      this.tooltipData.push(positionData);
    }
    this.tooltipPositions.emit(this.tooltipData);
  }

  //Send request for all fields to do evaluate, from block
  runEvaluateAllComponents(displayErrors: boolean): boolean {
    var groupHasErrors = false;
    this.componentForms.forEach(componentForm => {
      // Timeout breaks the process. (dont use here)
        var compHasErrors = componentForm.evaluateAllComponentFields(true, displayErrors);
        if (!groupHasErrors && compHasErrors) {
          groupHasErrors = compHasErrors;
        }
    });

    return groupHasErrors;
  }


  getCurrentUserRole(isPreview: boolean, pageId: string): RoleType
  {
    var userRole = RoleType.INTERN;
    this.auth.getUserRoleNotAsync()
    .subscribe(role => {
      if (role !== null) {
        userRole = role;
      }
    });

    if(isPreview){
      this.route.paramMap.subscribe(params => {
        this.route.queryParams.subscribe(queryParams => {
          var roleType = queryParams['role'];
          const roleStorageKey = `preview_${pageId}_${roleType}`;
          const existingPage = this.lStorage.getItemWithExpiry(roleStorageKey);
          if(existingPage)
          {
            userRole = existingPage.role;
          }
        });
      });
    }

    return userRole;
  }

  recalculateTooltipsPositionEmit()
  {
    setTimeout(() => {
      this.recalculateTooltipsPosition.emit();
    }, 0);
  }

  closeAllTooltipsExceptCurrentEmit(tooltipIndex: string)
  {
    setTimeout(() => {
      this.closeAllTooltipsExceptCurrent.emit(tooltipIndex);
    }, 0);
  }

  dataGroupHasMainActivityPrestations(dataGroup: KeyValue<string, CustomerPageData[]>): boolean{
    return dataGroup.value.some(x => x.component.type == ComponentType.ACTIVITY_PRESTATIONS && (x.values[0] as ContentActivityPrestations)?.activity?.mainIndicator === true);
  }

  dataGroupHasNotMainActivityPrestations(dataGroup: KeyValue<string, CustomerPageData[]>): boolean{
    return dataGroup.value.some(x => x.component.type == ComponentType.ACTIVITY_PRESTATIONS && (x.values[0] as ContentActivityPrestations)?.activity?.mainIndicator !== true);
  }

  dataComponentIsMainActivityPrestations(dataComponent: CustomerPageData): boolean{
    return dataComponent.component.type == ComponentType.ACTIVITY_PRESTATIONS && (dataComponent.values[0] as ContentActivityPrestations)?.activity?.mainIndicator === true
  }

  findDataComponentWithMainIndicator(): CustomerPageData | undefined {
    for (const groupValues of Object.values(this.customersDataGrouped)) {
      const found = groupValues.find(dataComponent => {
        if (dataComponent.component.type === ComponentType.ACTIVITY_PRESTATIONS) {
          const value = dataComponent.values as ContentActivityPrestations[];
          return value[0]?.activity?.mainIndicator === true;
        }
        return false;
      });

      if (found) {
        return found;
      }
    }

    return undefined;
  }

  onUpdateActivityPrestationMainIndicator(dataGroup: KeyValue<string, CustomerPageData[]>){
    if(this.groupHasActivityPrestations)
    {
      this.dialogService.confirm(this.translationService.translate('Set as main'), this.translationService.translate('Are you sure you want to set this activity as your main one?')).then((confirmed) => {
        if (confirmed) {
          if(!this.isPreview){
            //update main activity with main false, without save
            var dataComponentMain = this.findDataComponentWithMainIndicator();
            const dataComponentMainForm = this.componentForms.find(cf =>
              cf.customerPageData.id === dataComponentMain?.id
            );
            dataComponentMainForm?.onUpdateActivityPrestationMainIndicator(false, false);

            //update target activity with main true, with save
            var dataComponentToBeMain = dataGroup.value.find(x => x.component.type == ComponentType.ACTIVITY_PRESTATIONS);
            const dataComponentToBeMainForm = this.componentForms.find(cf =>
              cf.customerPageData.id === dataComponentToBeMain?.id
            );
            dataComponentToBeMainForm?.onUpdateActivityPrestationMainIndicator(true, true);
          }
          else {
            //in preview we dont have customerPageData id

            //update main activity with main false, without save
            var dataComponentMain = this.findDataComponentWithMainIndicator();
            const dataComponentMainForm = this.componentForms.find(cf =>
              cf.component.type == ComponentType.ACTIVITY_PRESTATIONS
              && cf.customerPageData.dataGroupId == dataComponentMain?.dataGroupId
            );
            dataComponentMainForm?.onUpdateActivityPrestationMainIndicator(false, false);

            //update target activity with main true, with save
            var dataComponentToBeMain = dataGroup.value.find(x => x.component.type == ComponentType.ACTIVITY_PRESTATIONS);
            const dataComponentToBeMainForm = this.componentForms.find(cf =>
              cf.component.type == ComponentType.ACTIVITY_PRESTATIONS
              && cf.customerPageData.dataGroupId == dataComponentToBeMain?.dataGroupId
            );
            dataComponentToBeMainForm?.onUpdateActivityPrestationMainIndicator(true, true);
          }

          this.refreshCustomersDataGrouped();
        }
      });
    }
  }

  activitiesAlreadySelected: string[] = [];

  onActivityChanged(){
    this.activitiesAlreadySelected = this.calculateActivitiesSelected();

    this.componentForms
    .filter(c => c.component.type == ComponentType.ACTIVITY_PRESTATIONS)
    .forEach(c =>
      setTimeout(() => {
        c.updateAvailableActivities()
      }, 0)
    )
  }

  calculateActivitiesSelected(){
    return (this.customerPageDataGroup
    .filter(d => d.component.type == ComponentType.ACTIVITY_PRESTATIONS && d.values.length > 0)
    .flatMap(d => d.values) as ContentActivityPrestations[])
      .flatMap(v => v.activity)
      .filter(a => a != undefined)
      .flatMap(a => a!.code);
  }
}
